import PropertyProfile from './PropertyProfile.vue';

export default PropertyProfile;